import { render, staticRenderFns } from "./search-reset-button.vue?vue&type=template&id=173abddc&"
import script from "./search-reset-button.vue?vue&type=script&lang=js&"
export * from "./search-reset-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports